import React from 'react';
import { useNavigate } from 'react-router-dom';
import './homeservice.css';
import {
  Users,
  Briefcase,
  GraduationCap,
  Globe,
  Shield,
  ChevronRight,
} from 'lucide-react';

const services = [
  {
    title: "Cloud & Infrastructure Consulting",
    description:
      "Expertise in cloud architecture, hybrid strategies, serverless, and IaC on AWS, Azure, and GCP.",
    icon: <Globe className="service-icon" size={28} />,
  },
  {
    title: "DevOps & Site Reliability Engineering (SRE)",
    description:
      "CI/CD, container orchestration, observability, and DevSecOps practices for high-performing systems.",
    icon: <Users className="service-icon" size={28} />,
  },
  {
    title: "AI, Data & Analytics",
    description:
      "End-to-end data engineering, ML ops, BI, chatbot solutions, and data governance.",
    icon: <GraduationCap className="service-icon" size={28} />,
  },
  {
    title: "Application Development & Integration",
    description:
      "Custom app development, API integration, and enterprise systems using modern frameworks.",
    icon: <Briefcase className="service-icon" size={28} />,
  },
  {
    title: "Cybersecurity & Compliance",
    description:
      "Comprehensive security audits, IAM, SOC setup, and compliance with ISO, NIST, GDPR.",
    icon: <Shield className="service-icon" size={28} />,
  },
  {
    title: "IT Staffing & Talent Acquisition",
    description:
      "Contract, freelance, executive tech staffing and recruitment process outsourcing (RPO).",
    icon: <Users className="service-icon" size={28} />,
  },
  // {
  //   title: "Project Delivery & Managed Services",
  //   description:
  //     "Agile teams, managed IT projects, 24x7 support, and dedicated helpdesk services.",
  //   icon: <Briefcase className="service-icon" size={28} />,
  // },
];

function HomeServiceComponent() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/services');
    window.scrollTo(0, 0);
  };

  return (
    <section className="home-service-section" id="services">
      <h4 className="home-service-subtitle">Our Services</h4>
      <h2 className="home-service-title">End-to-End IT Consulting & Recruitment Solutions Across Europe</h2>
      <div className="home-service-grid">
        {services.map((service, index) => (
          <div className="home-service-card" key={index}>
            <div className="icon-wrapper">{service.icon}</div>
            <h3 className="service-heading">{service.title}</h3>
            <p className="service-text">{service.description}</p>
          </div>
        ))}
      </div>
      <button onClick={handleNavigate} className="homeabout-button">
          <span>See more</span>
          <ChevronRight size={20} />
        </button>
    </section>
  );
}

export default HomeServiceComponent;
